import { useContext } from "react";
import { NavContext } from "../Nav/NavContext";
import {
  closeUserMenu as closeUserMenuAction,
  openUserMenu as openUserMenuAction
} from "../Nav/reducer";

export function useUserMenu() {
  const [state, dispatch] = useContext(NavContext);
  const { isUserMenuOpen } = state;

  const toggleUserMenu = () =>
    dispatch(isUserMenuOpen ? closeUserMenuAction() : openUserMenuAction());
  const openUserMenu = () => dispatch(openUserMenuAction());
  const closeUserMenu = () => dispatch(closeUserMenuAction());

  return {
    isUserMenuOpen,
    toggleUserMenu,
    closeUserMenu,
    openUserMenu
  };
}
